import styled from "styled-components";
import {
  responsive,
  tabletAboveRange,
} from "../../../../../../styles/constants.style";

export const TransferProgramsWrapper = styled.div`
  padding: 16px;

  ${responsive.MOBILE`
    padding: 0px 8px;
  `}

  .transfer-container-bulk {
    padding: 0;
    ${responsive.MOBILE`
      padding: 16px 0px;
    `}
  }

  .warning-icon {
    margin: 0 6px 2px 0;
  }

  .transfer-field {
    padding-right: 16px;
    ${responsive.MOBILE`
        padding-right: 0px;
         > div {
            margin-top: 16px;
          }
      `}

    ${tabletAboveRange`
        &:nth-child(3) {
          margin-top: 24px;
        }
    `}
  }

  .activity-info {
    margin: 0px;
  }

  .value-style {
    line-height: 22px;
  }
`;
